export default __webpack_public_path__ + "static/media/logo_normal.30fa52b4.svg";